import Vue from 'vue'
import VueRouter from 'vue-router'

import __ from 'lodash';

import store from '../store/index.js';

Vue.use(VueRouter)

const routes = [
  { // 로그인 페이지
    path: '/',
    name: 'login',
    component: () => import('@/views/login/login.vue'),
  },
  { // 회원가입 페이지
    path: '/jointype',
    name: 'joinType',
    component: () => import('@/views/login/joinType.vue'),
  },
  { // 회원가입 페이지
    path: '/join',
    name: 'join',
    component: () => import('@/views/login/join.vue'),
  },
  { // 가입환영 페이지
    path: '/welcomejoin',
    name: 'welcomejoin',
    component: () => import('@/views/login/welcomeJoin.vue'),
  },
  { // 메인 페이지
    path: '/home',
    name: 'home',
    component: () => import('@/views/home.vue'),
  },
  { // 내정보 관리
    path: '/my-info',
    name: 'myInfo',
    component: () => import('@/views/my/info.vue'),
  },
  { // 마이페이지
    path: '/my-page',
    name: 'myPage',
    component: () => import('@/views/my/page.vue'),
  },
  {
    path: '/my-msg',
    name: 'myMsg', 
    component: () => import('@/views/my/msg.vue')
  },

  { // 영업아이템
    path: '/items',
    name: 'items',
    component: () => import('@/views/item/index.vue'),
  },
  { // 쇼핑몰
    path: '/products',
    component: () => import('@/views/product/index.vue'),
    children: [
      { // 메인 페이지
        path: 'home',
        name: 'productHome',
        component: () => import('@/views/product/home.vue'),
      },
      { // 상품 목록 페이지
        path: 'list',
        name: 'productList',
        component: () => import('@/views/product/list.vue'),
      },
      { // 상품 상세 페이지
        path: 'info',
        name: 'productInfo',
        component: () => import('@/views/product/info.vue'),
      },
      { // 상품 검색 페이지
        path: 'search',
        name: 'productSearch',
        component: () => import('@/views/product/search.vue'),
      },
      { // mark 페이지
        path: 'mark',
        name: 'productMark',
        component: () => import('@/views/product/mark.vue'),
      },
      { // 주문현황 페이지
        path: 'order',
        name: 'productOrder',
        component: () => import('@/views/product/order.vue'),
      },
      { // 주문현황 페이지
        path: 'order',
        name: 'productOrderDetail',
        component: () => import('@/views/product/orderDetail.vue'),
      },
      { // 최근 본 상품 목록 페이지
        path: 'visit',
        name: 'productVisit',
        component: () => import('@/views/product/visit.vue'),
      },
    ]
  },
  { // 장바구니
    path: '/cart',
    name: 'cart',
    component: () => import('@/views/cart.vue'),
  },
  { // 구매페이지
    path: '/buy',
    name: 'buy',
    component: () => import('@/views/buy.vue'),
  },

  { // 사업왕
    path: '/businesses',
    component: () => import('@/views/business/index.vue'),
    children: [
      { // 메인 페이지
        path: 'home',
        name: 'businessHome',
        component: () => import('@/views/business/home.vue'),
      },
      { // lg
        path: 'lg',
        name: 'businessLg',
        component: () => import('@/views/business/lg.vue'),
      },
      { // oneshot
        path: 'oneshot',
        name: 'businessOneShot',
        component: () => import('@/views/business/oneShot.vue'),
      },
      { // samsung
        path: 'samsung',
        name: 'businessSamsung',
        component: () => import('@/views/business/samsung.vue'),
      },
    ]
  },
  { // 여행왕
    path: '/travels',
    component: () => import('@/views/travel/index.vue'),
    children: [
      { // 메인 페이지
        path: 'home',
        name: 'travelHome',
        component: () => import('@/views/travel/home.vue'),
      },
    ]
  },
  { // 건강왕
    path: '/health',
    component: () => import('@/views/health/index.vue'),
    children: [
      { // 메인 페이지
        path: 'home',
        name: 'healthHome',
        component: () => import('@/views/health/home.vue'),
      },
    ]
  },

  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/views/terms/index.vue'),
  },
  {
    path: '*',
    redirect: {name: 'home'}
    // 미로그인시에는 '/', 로그인시에는 '/home' 으로 튕기로록 세팅
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async(to, from, next) => {
  // check login
  // console.log('router beforeEach: ', $cookies.isKey('isLogin'));
  // console.log('to: ', to, 'from: ', from);
  // console.log('user info: ', __.isEmpty(store.state.user.grade), __.isEmpty(store.state.user), store.state.user);
  const isLogin = $cookies.isKey('isLogin');

  if(isLogin) { // 로그인되있는 상태이면, 기본 유저정보가 저장되있는지 확인 후, 없는 경우 조회 & 저장
    if( __.isEmpty(store.state.user.id) ) {
      store.dispatch('setUser');
    }
  } else { // 미 로그인시, 기본 유저 정보 삭제
      store.dispatch('delUser');
  }
  const nonRequiredAuthPath = [ // 미로그인 상태에서만 접근 가능한 페이지 목록
    '/',
    '/join',
  ];
  const requiredAuthPath = [ // 인증이 필요한 페이지 목록
    '/home', '/my-info', '/products/home', '/cart', '/buy'
  ];
  if(nonRequiredAuthPath.findIndex(e => e === to.path) !== -1 && isLogin) { // 로그인 상태에서 접근 불가 페이지 처리
    next('home');
  } else if(requiredAuthPath.findIndex(e => e === to.path) !== -1 && !isLogin) { // 인증 필요 페이지 접근 불가 처리
    next('/');
  } else {
    next();
  }
})

export default router
